module.exports = __webpack_public_path__ + "static/media/casino1.ffe898d4.jpeg";